/* src/app/views/area-publica/catalogo-projetos/catalogo-projetos-public/catalogo-projetos-public.component.scss */
.header .title {
  font-size: 32px;
  font-weight: 500;
  color: #007AC2;
}
.project-list {
  background-color: #ffffff;
}
.project-list .margin {
  margin: 3.5%;
  margin-right: -16px;
}
.no-content {
  width: 360px;
  margin: 0 auto;
}
.no-content .no-content-desc {
  font-size: 34px;
  font-weight: 500;
  color: #2E3241;
}
.no-content .no-content-pic {
  height: 180px;
}
.form-title {
  font-size: 16px;
  color: #007ac2;
}
#limpar-filtros {
  margin-bottom: 32px;
}
.form {
  margin-right: 0;
  width: 20%;
  max-height: calc(100vh - (5% + 120px));
  overflow-y: scroll;
  padding-bottom: 20px;
  box-sizing: content-box;
}
::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}
#limpar-filtros {
  text-align: right;
  color: #f4465a;
  cursor: pointer;
}
.disabled {
  cursor: not-allowed;
}
:host ::ng-deep .mat-form-field-infix {
  border-top: none !important;
}
/*# sourceMappingURL=catalogo-projetos-public.component.css.map */
